<template>
  <g fill-rule="evenodd" fill="none">
    <path d="M-1.687-1.687h23.374v23.374H-1.687V-1.687z" />
    <path d="M18.766 10L3.183 19.739V.259L18.766 10z" fill-rule="nonzero" :fill="color" />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
